export const imgixDomain = '451.imgix.net';

// Get the imgix path without base domain
const imgixDomainRegex = new RegExp(`http(s?):\/\/${imgixDomain}\/`, 'gi');

export const imgixPath = (url: string) => {
  const path = url?.replace(imgixDomainRegex, '');
  return decodeURIComponent(path);
};
